import React from 'react';
import createReactClass from 'create-react-class';

import axios from '@/util/axios';
import { addToast, handleAxiosError, removeModal } from 'core/notifications';
import i18n from 'i18next';
import { withContainer } from 'core/cache';

import NewAudienceForm from '../components/newAudienceForm';

const NewAudienceFormContainer = createReactClass({
  getInitialState() {
    return { formState: {}, hasSubmitted: false, isSubmitting: false };
  },

  handleCancel() {
    removeModal();
  },

  handleDataErrors({ response }) {
    const { id, notificationsModalsById } = this.props;
    const model = notificationsModalsById.data[id];

    this.setState(({ formState }) => {
      response.data?.errors?.forEach(({ message, source }) => {
        const field = formState[source.split('data.').pop()];

        if (field) {
          Object.assign(field, { error: message, hasError: true });
        }
      });

      return { formState };
    });

    // trigger form update
    this.setModel({});
    this.setModel(model);
    addToast(i18n.t('form-errors'), 'warning');
  },

  handleLoad({ formState }) {
    this.setState({ formState });
  },

  async handleSubmit() {
    const { id, notifications, notificationsModalsById } = this.props;
    let audience = notificationsModalsById.data[id];

    this.setState({ hasSubmitted: true, isSubmitting: true });

    try {
      ({ data: { data: audience } } = await axios.post('/api/admin/audiences', {
        data: audience,
      }));
    } catch (error) {
      this.setState({ isSubmitting: false });

      if (error.response?.status === 422) {
        return this.handleDataErrors(error);
      }

      return handleAxiosError(error);
    }

    const { modals } = notifications.data;

    modals[modals.length - 1].commitAction({ type: 'save', payload: audience });
  },

  handleUpdate({ formState, update }) {
    const { id, notificationsModalsById } = this.props;

    this.setState({ formState });
    this.setModel({ ...notificationsModalsById.data[id], ...update });
  },

  setModel(data) {
    const { id, notificationsModalsById } = this.props;

    notificationsModalsById.set({ [id]: data }, { setType: 'extend' });
  },

  render() {
    const { formState, hasSubmitted, isSubmitting } = this.state;
    const { id, notificationsModalsById, schema } = this.props;

    return (
      <NewAudienceForm
        hasError={Object.values(formState).some(({ hasError }) => hasError)}
        hasSubmitted={hasSubmitted}
        isSubmitting={isSubmitting}
        model={notificationsModalsById.data[id]}
        onCancel={this.handleCancel}
        onLoad={this.handleLoad}
        onSubmit={this.handleSubmit}
        onUpdate={this.handleUpdate}
        schema={schema}
      />
    );
  },
});

export default withContainer(NewAudienceFormContainer, {
  cache: {
    notifications: { isListener: true },
    notificationsModalsById: { isListener: true },
  },
});
